import Logo from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';

const PRIMITIVES = [
  { label: 'Auth', color: 'bg-violet', status: 'in alpha' },
  { label: 'Store', color: 'bg-cyan', status: 'in design' },
  { label: 'Comms', color: 'bg-amber', status: 'planned' },
  { label: 'Realtime', color: 'bg-pink', status: 'planned' },
];

export default function ComingSoon() {
  return (
    <main className="relative flex min-h-screen flex-col">
      {/* ambient brand halo */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-[640px] max-w-[1100px] opacity-[0.55] blur-3xl"
        style={{
          background:
            'radial-gradient(60% 50% at 50% 30%, rgba(124,58,237,0.18) 0%, rgba(236,72,153,0.08) 50%, transparent 75%)',
        }}
      />

      {/* minimal top bar — logo + theme toggle only */}
      <header className="relative z-10">
        <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-6 py-6 lg:px-8">
          <Logo />
          <ThemeToggle />
        </div>
      </header>

      {/* hero */}
      <section className="relative z-10 flex flex-1 items-center">
        <div className="mx-auto w-full max-w-[820px] px-6 pb-24 pt-16 text-center lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-surface px-3 py-1 text-[12px] text-body shadow-hair">
            <span className="relative grid place-items-center">
              <span className="absolute size-3 animate-pulse-soft rounded-full bg-violet/30" />
              <span className="size-1.5 rounded-full bg-violet" />
            </span>
            Alpha · private build · invite only
          </span>

          <h1 className="mt-8 font-bold tracking-tighter text-ink text-[56px] leading-[1.05] sm:text-[72px] lg:text-[88px] animate-fade-in">
            Almost <span className="bg-pryma-grad bg-clip-text text-transparent">here.</span>
          </h1>

          <div className="mx-auto mt-7 flex h-[3px] w-[360px] max-w-full overflow-hidden rounded-full">
            <span className="flex-1 bg-violet" />
            <span className="flex-1 bg-violetMid" />
            <span className="flex-1 bg-cyan" />
            <span className="flex-1 bg-amber" />
            <span className="flex-1 bg-pink" />
          </div>

          <p className="mx-auto mt-7 max-w-[560px] text-[18px] leading-[1.55] text-body">
            Pryma is the base layer for modern apps — auth, store, comms, and realtime under one
            SDK. We're still in alpha. Public launch follows once auth is production-ready.
          </p>

          <div className="mx-auto mt-10 grid max-w-[640px] grid-cols-2 gap-3 sm:grid-cols-4">
            {PRIMITIVES.map(p => (
              <div
                key={p.label}
                className="flex flex-col items-center gap-2 rounded-xl border border-border bg-surface px-3 py-4 text-center shadow-hair"
              >
                <span className={`size-1.5 rounded-full ${p.color}`} />
                <span className="text-[13px] font-semibold text-ink">{p.label}</span>
                <span className="font-mono text-[10px] uppercase tracking-wider text-muted">
                  {p.status}
                </span>
              </div>
            ))}
          </div>

          <p className="mt-12 font-mono text-[12px] text-muted">
            For early access, reach out to{' '}
            <a
              href="mailto:hello@pryma.dev"
              className="text-violet underline-offset-2 transition-colors hover:text-violetMid hover:underline"
            >
              hello@pryma.dev
            </a>
            .
          </p>
        </div>
      </section>

      {/* minimal footer line */}
      <footer className="relative z-10 border-t border-border">
        <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-6 py-5 lg:px-8">
          <p className="text-[12px] text-muted">© 2026 Pryma. All primitives reserved.</p>
          <p className="font-mono text-[11px] text-muted">pryma.dev</p>
        </div>
      </footer>
    </main>
  );
}
